import { ManageGuestWaitlistEditPage } from './manage-guest-waitlist-edit.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: ManageGuestWaitlistEditPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageGuestWaitlistEditPageRoutingModule {}
